import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/home/home.vue' //首页
//const Home = () => import('../pages/home/home.vue') //个人中心
import Login from '../pages/login/login.vue' //登录页
import not_found from '../pages/not_found/not_found.vue' //404页面
const UserCenter = () => import('../pages/userCenter/userCenter.vue') //个人中心
const UserEdit = () => import('../pages/userCenter/userEdit.vue') //编辑资料
const AboutUs = () => import('../pages/aboutUs/aboutUs.vue') //加入社群
const Verify = () => import('../pages/verify/verify.vue') //防伪核验
const Products = () => import('../pages/products/products.vue') //全部产品
const Peripherals = () => import('../pages/products/peripherals.vue') //周边产品
const ProductInfo = () => import('../pages/productInfo/productInfo.vue') //全部产品详情
const PeripheralInfo = () => import('../pages/productInfo/peripheralInfo.vue') //周边产品详情
const Serve = () => import('../pages/serve/serve.vue') //服务相关
const AfterSales = () => import('../pages/serve/afterSales.vue') //售后服务
const Agreement = () => import('../pages/serve/agreement.vue') //服务条款
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history', //HTML5 History 模式
  routes: [{
      path: '/home',
      meta: {
        title: '首页',
        islogin: false,
        keepAlive: false
      },
      redirect: '/'
    },
    {
      path: '/',
      name: 'home',
      meta: {
        title: '首页',
        islogin: false,
        keepAlive: false
      },
      component: Home

    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录',
        islogin: false,
        keepAlive: true
      },
      component: Login
    },
    {
      path: '/signUp',
      name: 'signUp',
      meta: {
        title: '注册',
        islogin: false,
        keepAlive: true
      },
      component: Login
    },
    {
      path: '/reset',
      name: 'reset',
      meta: {
        title: '修改密码',
        islogin: false,
        keepAlive: true
      },
      component: Login
    },
    {
      path: '/userCenter',
      name: 'userCenter',
      meta: {
        title: '个人中心',
        islogin: true
      },
      component: UserCenter

    },
    {
      path: '/userEdit',
      name: 'userEdit',
      meta: {
        title: '编辑资料',
        islogin: true
      },
      component: UserEdit

    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      meta: {
        title: '加入社群',
        islogin: false,
        keepAlive: true
      },
      component: AboutUs

    },
    {
      path: '/verify',
      name: 'verify',
      meta: {
        title: 'Snail Shell',
        islogin: false,
        keepAlive: false
      },
      component: Verify

    },
    {
      path: '/products',
      name: 'products',
      meta: {
        title: 'products',
        islogin: false
      },
      component: Products

    },
    {
      path: '/peripherals',
      name: 'peripherals',
      meta: {
        title: 'peripherals',
        islogin: false
      },
      component: Peripherals

    },
    {
      path: '/productInfo/:id',
      name: 'productInfo',
      meta: {
        title: 'productInfo',
        islogin: false
      },
      props: (route) => ({
        ...route.params
      }),
      component: ProductInfo

    },
    {
      path: '/peripheralInfo/:id',
      name: 'peripheralInfo',
      meta: {
        title: 'peripheralInfo',
        islogin: false
      },
      props: (route) => ({
        ...route.params
      }),
      component: PeripheralInfo

    },
    {
      path: '/serve',
      name: 'serve',
      meta: {
        title: 'serve',
        islogin: false,
        keepAlive: true
      },
      component: Serve,
      redirect: '/afterSales',
      children: [{
          path: '/afterSales',
          name: 'afterSales',
          meta: {
            title: 'afterSales',
            islogin: false,
            keepAlive: true
          },
          component: AfterSales
        },
        {
          path: '/agreement',
          name: 'agreement',
          meta: {
            title: 'agreement',
            islogin: false,
            keepAlive: true
          },
          component: Agreement
        }
      ]
    },
    {
      path: "/404",
      name: "404",
      component: not_found
    },
    {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/404"
    }

  ],

})

export default router
//路由监听导航守卫
router.beforeEach((to, from, next) => {
  // document.title = to.meta.title ? to.meta.title : '天一网校'
  //验证登录权限
  if (to.meta.islogin) {
    //没有登录的情况下
    if (!localStorage.getItem('token')) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })

    } else {
      next();
    };
  } else {
    //不验证登录权限
    // console.log(to)
    //  console.log(document.documentElement.clientWidth)
    next();
  };
  window.scrollTo(0, 0)
})



// WEBPACK FOOTER //
// ./src/router/index.js